import axios from "axios";

const InitialState = {
  counterSkills: null,
  counterSpecialities: null
};

const MANAGE_OOP_RESOURCES_FGOS_INDEX_TYPE = "MANAGE_OOP_RESOURCES_FGOS_INDEX_TYPE";

function counterSkillsGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-dicts-skills", {
    headers: {'Accept': 'application/json'},
  });
}

function counterSpecialitiesGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-dicts-specialities", {
    headers: {'Accept': 'application/json'},
  });
}



function counterSkillsReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_FGOS_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterSkills: item
      }
    }
  }
}

function counterSpecialitiesReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_FGOS_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterSpecialities: item
      }
    }
  }
}

export function counterSkillsQuery() {
  return (dispatch) => {
    return counterSkillsGetRequest()
      .then(response => {
        dispatch(counterSkillsReceive(response.data))
      }, err => {
        dispatch(counterSkillsReceive(null))
      })
  }
}

export function counterSpecialitiesQuery() {
  return (dispatch) => {
    return counterSpecialitiesGetRequest()
      .then(response => {
        dispatch(counterSpecialitiesReceive(response.data))
      }, err => {
        dispatch(counterSpecialitiesReceive(null))
      })
  }
}

export function reducer(state = InitialState, action) {
  if (action.type === MANAGE_OOP_RESOURCES_FGOS_INDEX_TYPE) {
    return action.reduce(state)
  }
  return state;
}
